import { Module } from 'vuex'

export interface Share {
  username: string,
  token: string,
}

const shareModule: Module<any, any> = {
	actions: {
		async _GetContent({ commit }, {member}) {
			return {
				carousel: true,
				// link: 'socialhp.com',
				networks: ['linkedin', 'facebook', 'twitter', 'instagram'],
				titles: {
					linkedin: 'LinkedIn Preview Title',
					facebook: 'Facebook Preview Title',
					twitter: 'Twitter Preview Title'
				},
				descriptions: {
					linkedin: 'LinkedIn, the quick brown fox jumps over the lazy dog.',
					facebook: 'Facebook, the quick brown fox jumps over the lazy dog.',
					twitter: 'Twitter, the quick brown fox jumps over the lazy dog.'
				},
				messages: {
					linkedin: [
						'LinkedIn Message 1',
						'LinkedIn Message 2'
					],
					facebook: [
						'Facebook Message 1', 
						'Facebook Message 2',
						'Facebook Message 3'
					],
					twitter: [
						'Twitter Message 1'
					]
				},
				images: {
					linkedin: [
						'/images/cards/img-01.png',
						'/images/cards/img-02.png',
						'/images/cards/img-18.png'
					],
					facebook: [
						'/images/cards/img-01.png',
						'/images/cards/img-02.png',
						'/images/cards/img-03.png',
						'/images/cards/img-04.png',
						'/images/cards/img-05.png',
						'/images/cards/img-18.png'
					],
					twitter: [
						'/images/cards/img-05.png',
						'/images/cards/img-18.png'
					]
				},
				videos: {
					linkedin: ['/videos/video-01.mp4'],
					facebook: [],
					twitter: []
				}
			}
		},

		async _GetTeamMembers({ commit }, {member}) {
			return [
				{
					id: 1,
					rank: 23,
					name: 'John Doe',
					image: '/images/profile-img/img-02.jpg',
					username: '@johndoe',
					email: 'johndoe@example.com',
					autopilot: true,
					executive: true,
					networks: ['linkedin', 'facebook', 'twitter']
				},
				{
					id: 2,
					rank: 2,
					name: 'Mary Jane',
					image: '/images/profile-img/img-03.jpg',
					username: '@maryjane',
					email: 'maryjane@example.com',
					autopilot: false,
					executive: true,
					networks: ['linkedin', 'facebook']
				},
				{
					id: 3,
					rank: 13,
					name: 'Foo Bar',
					image: '/images/profile-img/img-04.jpg',
					username: '@foobar',
					email: 'foobar@example.com',
					autopilot: false,
					executive: false,
					networks: ['facebook', 'twitter']
				},
				{
					id: 4,
					rank: 89,
					name: 'John Paul',
					image: '/images/profile-img/img-05.jpg',
					username: '@johnpaul',
					email: 'johnpaul@example.com',
					autopilot: true,
					executive: false,
					networks: ['twitter']
				}
			]
		}
	}
}

export default shareModule